import { SVGProps } from 'react';

const B2B = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M8.25 7.75h-4.5V8l.01.223A2.25 2.25 0 0 0 8.25 8v-.25Zm6 9.25A1.25 1.25 0 0 0 13 15.75h-2A1.25 1.25 0 0 0 9.75 17v3.25h4.5V17ZM4.214 6.25h15.572l-1.25-2.5H5.464l-1.25 2.5Zm11.536 14h2.5v-8.51A3.75 3.75 0 0 1 15 10.248a3.75 3.75 0 0 1-6 0 3.75 3.75 0 0 1-3.25 1.492v8.51h2.5V17A2.75 2.75 0 0 1 11 14.25h2A2.75 2.75 0 0 1 15.75 17v3.25ZM9.75 8a2.25 2.25 0 0 0 4.5 0v-.25h-4.5V8Zm6 0a2.25 2.25 0 0 0 4.49.223L20.25 8v-.25h-4.5V8Zm6 0a3.75 3.75 0 0 1-2 3.316v8.934H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h1.25v-8.934A3.749 3.749 0 0 1 2.25 8V7a.75.75 0 0 1 .08-.335l2-4A.75.75 0 0 1 5 2.25h14l.105.008a.75.75 0 0 1 .566.407l2 4A.75.75 0 0 1 21.75 7v1Z"
    />
  </svg>
);

export default B2B;
